<template>
  <fsquick-card title="Fees Structure">
  <template v-slot:header-actions>
     <v-btn color="primary" icon class="elevation-3" @click="showD=!showD">
          <v-icon>add</v-icon>
     </v-btn>
     <v-spacer></v-spacer>
       <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
  </template>
    <template v-slot:card-content>
         <v-data-table
                    :headers="fee_str_headers"
                    :items="feestrs"
                    class="elevation-0"
                    :search="search"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.name }}</td>
                      <td class="text-xs-center">{{ props.item.basic_amt | toCurrency}}</td>
                      <td class="text-xs-center">{{ props.item.adcharges_sum | toCurrency}}</td>
                      <td class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <v-btn flat icon color="blue" @click="editfeestr(props.item)">
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-btn
                              flat
                              icon
                              color="pink"
                              @click="deletefeestr(props.item, props.item.index)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>

                  <m-dialog title="Fee Structure" :show="showD" pers>

                    <template v-slot:header-actions>
                      <v-btn @click="showD=!showD" icon style="cursor:pointer">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:content>
                        <v-form ref="form">
                        <v-text-field label="Fee Str. Name" v-model="feestr_model.name" :rules="validRules.required"/>

                        <v-text-field label="Basic Amount (GHS)" v-model="feestr_model.basic_amt" type="number" step="any" :rules="validRules.required"/>
                        <v-autocomplete
                          label="Additional Charges:"
                          :items="adcharges"
                          :multiple="true"
                          :chips="true"
                          item-value="id"
                          item-text="charge_item"
                          :clearable="true"
                          :loadin="acloading"
                          v-model="feestr_model.adcharges"
                          :deletable-chips="true"
                          :rules="validRules.required"
                        ></v-autocomplete>
                      </v-form>

                    </template>

                    <template v-slot:footer-actions>
                       <v-btn style="cursor:pointer" color="success" :loading="loading" @click="savefeestr()">
                       save
                      </v-btn>
                      <v-btn @click="showD=!showD" style="cursor:pointer" color="error">
                       close
                      </v-btn>

                    </template>


                  </m-dialog>
    </template>
  </fsquick-card>
</template>

<script>
import {mapGetters} from 'vuex';
import QuickCard from "../Quickcard";
import Mdialog from "../Modal"
export default {
  name: "fees-structure",
  components: {
    "fsquick-card": QuickCard,
     "m-dialog":Mdialog,
  },
   data() {
    return {
      showD:false,
      pers:false,
      search:'',
      editedIndex:-1,
      feestr_model:{
        name:'',
        acyear_id:'',
        term_id:'',
        basic_amt:'',
        adcharges:[]
      },
       feestr_modelcp:{
        name:'',
        acyear_id:'',
        term_id:'',
        basic_amt:'',
        adcharges:[]
      },
      fee_str_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn"
        },
        {
          text: "Fee Str. Name",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Basic Amount(GHS)",
          align: "center",
          sortable: false,
          value: "basic_amt"
        },
         {
          text: "Additional Charges(GHS)",
          align: "center",
          sortable: false,
          value: "b_amount"
        },
         {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],

    }
  },

   mounted() {
    this.$store.dispatch("feestrs/getAll");
    this.$store.dispatch("adcharges/getAll");

  },
  computed: {
    ...mapGetters({
      feestrs: "feestrs/FEESTRS",
      fserrors: "feestrs/FEESTR_ERROR",
      loading: "feestrs/FEESTR_LOADING",

      adcharges: "adcharges/ADCHARGES",
      acerrors: "adcharges/ADCHARGE_ERROR",
      acloading: "adcharges/ADCHARGE_LOADING"
    })
  },
  methods: {
    sumadcharges(chgs){
      let res = chgs.reduce((total,item)=>{
        return total + parseFloat(item.amount)
      },0);

      return res
    },
      addfeestr() {
      this.$store.dispatch("feestrs/add", this.feestr_model);

      if (this.fserrors==null) {
        this.feestr_model = this.feestr_modelcp;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Fee structure saved successfully",
                title: "Fee Structure",
                modal: false
            })

      }
    },
    deletefeestr(feestr, index) {
      let idx = this.feestrs.indexOf(feestr);
      if (confirm("Are you sure you want to delete this feestr? Some classes may have been billed with this structure please check.")) {
        this.$store.dispatch("feestrs/delete", { feestr, index:idx });
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Fee structure deleted successfully",
                title: "Fee Structure",
                modal: false
            })
      }
    },

    editfeestr(feestr) {
      this.editedIndex = this.feestrs.indexOf(feestr);
      this.feestr_model = Object.assign({}, feestr);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updatefeestr(feestr, index) {
      let ac =feestr.adcharges;
      if(ac.length>0){
        if(ac[0].charge_item){
          feestr.adcharges = ac.map(i=>i.id); //changing adcharges to ids only while ignoring all other data incase it is an array of adcharge objects and not array of ids of adcharge objects. The problem happens when you save without changing any of the adcharges

        }
      }

      this.$store.dispatch("feestrs/update", { index, feestr });

      if (this.ferrors==null) {
        this.feestr_model = this.feestr_modelcp;
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Fee structure updated successfully",
                title: "Fee Structure",
                modal: false
            })
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry fee structure could not be updated",
                title: "Fee Structure",
                modal: false
            })
      }
    },
    savefeestr() {
      if (!this.$refs.form.validate()) {
        return;
      }


      //decides between editing feestr info or saving feestr info
      if (this.editedIndex > -1) {
        this.updatefeestr(this.feestr_model, this.editedIndex);
      } else {
        this.addfeestr();
      }
    }
  },
    watch:{
    showD(val){
      if(val==false){
        this.feestr_model = this.feestr_modelcp;
      }
    },

  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/feesStructure.vue